/**
* Image Gallery JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Gallery component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'image-gallery',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.image-gallery' ).each( function( key, val ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 50%',
            end: 'bottom 50%',
            scrub: 0,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).find( '.image-wrapper' ).addClass( 'is-loaded' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => $( this ).find( '.image-wrapper' ).addClass( 'is-loaded' ),
            // markers: true,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-gallery', COMPONENT );
} )( app );
